import Repository from "./Repository";
import {empty} from "../../shared/utils";

export default {
  searchCampaigns(search) {
    let query = '?'
    if (!empty(search.name)) {
      query += '&name='+search.name;
    }

    if (!empty(search.limit)) {
      query += '&limit='+search.limit
    }

    if (!empty(search.page)) {
      query += '&page='+search.page
    }

    return Repository.get('campaigns' + query)
  },
}
